<template>
    <el-dialog v-model="editDialogVisible" :title="title" width="585px" center>
        <div>
            <div class="score-box" v-if="question.icon === 'Number'">
                <div class="score-icon" v-for="(item, index) in 5" :key="index">
                    <div
                        class="score-icon_number"
                        :style="{
                            background: choseIconIndex > index ? 'rgba(34, 64, 195, 1)' : '',
                            color: choseIconIndex > index ? '#fff' : '',
                        }"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>
            <div v-else class="score-box">
                <div class="score-icon" v-for="(item, index) in 5">
                    <div class="icon-box">
                        <img v-if="choseIconIndex > index" :src="getAssetsImages(questionC.icon + '_light')" />
                        <img v-else :src="getAssetsImages(questionC.icon)" />
                    </div>
                </div>
            </div>
            <div class="explain">{{ questionC.explainsList[choseIconIndex].explainDes }}</div>
            <div class="tags-box">
                <div class="tag" v-for="(item, index) in questionC.explainsList[choseIconIndex].tagsList" :key="index">
                    {{ item }}
                </div>
                <div class="tag">写评分<svg-icon name="Vector" class="icon" /></div>
            </div>
            <el-tabs v-model="choseIconIndex" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane label="1分" name="1">
                    <EQ-edit-option :data="questionC.explainsList['1']" />
                </el-tab-pane>
                <el-tab-pane label="2分" name="2">
                    <EQ-edit-option :data="questionC.explainsList['2']" />
                </el-tab-pane>
                <el-tab-pane label="3分" name="3">
                    <EQ-edit-option :data="questionC.explainsList['3']" />
                </el-tab-pane>
                <el-tab-pane label="4分" name="4">
                    <EQ-edit-option :data="questionC.explainsList['4']" />
                </el-tab-pane>
                <el-tab-pane label="5分" name="5">
                    <EQ-edit-option :data="questionC.explainsList['5']" />
                </el-tab-pane>
            </el-tabs>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmEdit">确认</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { ref, watch } from "vue";
import { getAssetsImages } from "../../utils/index";

import EQEditOption from "./components/EQEditOption.vue";

const emits = defineEmits(["confirmEdit"]);
const props = defineProps({
    title: {
        type: String,
        default: "编辑选项",
    },
    question: {
        type: Object,
        default: {},
    },
});
let questionC = ref({});
let editDialogVisible = ref(false);
let choseIconIndex = ref("");
watch(editDialogVisible, () => {
    initData();
});

defineExpose({ editDialogVisible });

const confirmEdit = async () => {
    await emits("confirmEdit", questionC.value);
    editDialogVisible.value = false;
};

const handleClick = (e) => {};

// 初始化数据
function initData() {
    questionC.value = JSON.parse(JSON.stringify(props.question));
    choseIconIndex.value = "1";
}
</script>
<style lang="scss" scoped>
::v-deep(.el-tabs__nav) {
    left: 50%;
    transform: translateX(-50%) !important;
}
::v-deep(.el-tabs__nav-wrap::after) {
    background-color: rgba(229, 232, 238, 1);
}
::v-deep(.el-tabs__item) {
    font-weight: 400;
    color: rgba(183, 186, 191, 1);
}
::v-deep(.el-tabs__item.is-active) {
    color: #2240c3;
}
::v-deep(.el-tabs) {
    --el-tabs-header-height: 30px;
}
.score-box {
    display: flex;
    justify-content: center;
    .score-icon {
        width: 32px;
        min-height: 32px;
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        img {
            width: 32px;
            height: 32px;
        }
    }
    .score-icon_number {
        width: 32px;
        height: 32px;
        border: 1px solid rgba(228, 229, 232, 1);
        color: rgba(102, 102, 102, 1);
        border-radius: 50%;
        line-height: 29px;
        text-align: center;
    }
}
.explain {
    text-align: center;
    margin-top: 10px;
}
.demo-tabs {
    margin-top: 24px;
}
.tags-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 12px;
    .tag {
        margin-left: 12px;
        margin-top: 12px;
        padding: 3px 8px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(183, 186, 191, 1);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 232, 238, 1);
        .icon {
            margin-left: 10px;
        }
    }
}
</style>
